export default __webpack_public_path__ + "static/media/portfolio_sugerido.ef644031.png";